import { Injectable } from '@angular/core';
// import { AdvanceFilterRecord } from '../components/advancefiltering/advancefilterrecord';
@Injectable()
export class UtilityService{
    private timeZoneOffset:number = 60000;
    private baseUrl:String = '/api/'
    
    public getBaseUrl(){
        return this.baseUrl;
    }

    public getInitalDate(dateValue:number|string):string{
        if(typeof dateValue === "string"){
            return dateValue.substring(0,10);
        }else if(typeof dateValue === "number"){
            return this.getStringDateFromNumber(dateValue);
        }else{
        /*use default date*/return dateValue; //new Date(data.createDate);
        }  
    }

    public getDateFromString(date:string, includeTimeZoneOffset = false):Date{
        let stringDate:Date = new Date(date);
        return new Date(stringDate.getTime()  + (includeTimeZoneOffset ? 0 : +(stringDate.getTimezoneOffset() *this.timeZoneOffset)) ); //+(stringDate.getTimezoneOffset() *this.timeZoneOffset));//remove the timzone offset
    }

    public sortObjectProp(propName:string, isAsc: boolean = true){
        return function compare(a:any, b:any) {
            return (a[propName] < b[propName] ? -1 : 1) * (isAsc ? 1 : -1);
        }
    }

    public getStringDateFromNumber(value:number, includeTime:boolean=false):string{
        let tempDate: Date = new Date(value)
        let date:Date = new Date(tempDate.getTime())//+(tempDate.getTimezoneOffset()*this.timeZoneOffset));
        let day = date.getDate();
        let month = date.getMonth()+1
        let year = date.getFullYear();
        let time = "";
        let miniutes = date.getMinutes()
        let hour = date.getHours() 
        if(includeTime){
            time = " " + (hour > 12 ? hour -12 : hour) +":"+ (miniutes<10 ? "0"+ miniutes : miniutes ) + (hour>12 ? " PM" : " AM");
        }
        if(day.toString().length===1 && month.toString().length ===1){
            return year+"-0"+month+"-0"+day + (includeTime ? time : "");
        }else if(month.toString().length ===1){
            return year+"-0"+month+"-"+day + (includeTime ? time : "");
        }else if(day.toString().length===1){
            return year+"-"+month+"-0"+day + (includeTime ? time : "");
        }else{
            return year+"-"+month+"-"+day + (includeTime ? time : "");
        }
    }

    public getTimeDiffInMin(initalDateTime:Date, compareDateTime:Date):number{
        let miliSecondsToMinute = 60000
        let startMin = initalDateTime.getTime()/miliSecondsToMinute;
        let endMin = compareDateTime.getTime()/miliSecondsToMinute;
        return endMin - startMin;
    }

    public roundUp(number:number, decPlaces:number){
        var numberOfDescimale = Math.pow(10, decPlaces)
        return Math.ceil( number * numberOfDescimale) / numberOfDescimale
    }
    public roundNumber(number:number, decPlaces:number){
        var numberOfDescimale = Math.pow(10, decPlaces)
        return Math.round( number * numberOfDescimale) / numberOfDescimale
    }

    public replaceAll(value:string, search:string, replace:string):string{
        return value.split(search).join(replace);
      }

    public openBlobDocumentInNewTab(data:any){
        let file = new Blob([data],{type:'application/pdf'});
        let urlDocument = URL.createObjectURL(file);
        var newwindow = window.open(urlDocument,"_blank");
        if (newwindow == null || typeof(newwindow)=='undefined') {
            return false;
        } else {
            newwindow.focus();
            return true;
        }
    }

    public openPdfDocumentInNewTab(url:string){
        var newwindow = window.open(url,"_blank");
        if (newwindow == null || typeof(newwindow)=='undefined') {
            return false;
        } else {
            newwindow.focus();
            return true;
        }
    }
    
    public searchArrayObjectNumber(array:any, property:string, value:any):{object:any,index:number}|null{
        for (let index = 0; index < array.length; index++) {
            if(array[index][property] === value){
                return {object:array[index],index:index};
            }
        }
        return null;
    }

    public searchArrayObject(array:any, property:string, value:any):{object:any,index:number}|null{
        for (let index = 0; index < array.length; index++) {
            if(array[index][property] === value){
                return {object:array[index],index:index};
            }
        }
        return null;
    }

    public searchArrayObjectStringIngnoreCase(array:any, property:string, value:string):{object:any,index:number}|null{
        for (let index = 0; index < array.length; index++) {
            if(array[index][property].toLowerCase() === value.toLowerCase()){
                return {object:array[index],index:index};
            }
        }
        return null;
    }

    public searchArrayObjectForHighestValue(array:any, property:string,highestValue:any):{object:any,index:number}|undefined{
        let returnObject:{object:any,index:number}|undefined
        if(array.length>0 && highestValue === null){
            highestValue = array[0][property];
            returnObject = {object:array[0],index:0};
        }
        for (let index = 0; index < array.length; index++) {
            if(array[index][property] > highestValue){
                highestValue = array[index][property]
                returnObject = {object:array[index],index:index};
            }
        }
        return returnObject;
    }

    public searchArrayObjectForLowestValue(array:any, property:string,lowestValue:any=null):{object:any,index:number}|undefined{
        let returnObject:{object:any,index:number}|undefined;
        if(array.length>0 && lowestValue === null){
            lowestValue = array[0][property];
            returnObject = {object:array[0],index:0};
        }
        for (let index = 0; index < array.length; index++) {
            if(array[index][property] < lowestValue){
                lowestValue = array[index][property]
                returnObject = {object:array[index],index:index};
            }
        }
        return returnObject
    }

    // public getdynamicFiltersFromAdvanceFilter(advanceFilters:AdvanceFilterRecord[]=[]):{column:string, operator:string, value:string}[]{
    //     let returnFilters:{column:string, operator:string, value:string}[]=[];

    //     advanceFilters.map((rec)=>{
    //         if( !rec.errorSelectedField && !rec.errorSelectedOperator && !rec.errorSelectedValue ){
    //             returnFilters.push({
    //                 column:rec.selectedField.dataColumn,
    //                 operator:rec.selectedOperator.operator,
    //                 value: rec.filterValue
                    
    //             })
    //         }
    //     });

    //     return returnFilters;
    // }

    // public sortArray(array:any[],property:string,ascDesc:string){

    //     //return array.sort((a,b)=>{this.compare(a[property],b[property],true)});
    //     array.sort((a:any,b:any)=>{
    //         return (a[property] < b[property] ? -1 : 1) * (isAsc ? 1 : -1);
    //     })
        
    // }

    // public compare(a:any,b:any, isAsc:boolean){
    //     return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
    // }

    public openPrintData(htmlData:string,portrait:boolean=true,options?:{header?:string,title?:string,style?:string,url?:string}):boolean{
        let success:boolean = true
        let pageContent:string = "";
        let withInch:number = 8;
        let title:string = "Print";
        let url:string = "printableData"
        let header:string = "";
        let style = 'th.mat-header-cell, td.mat-cell, td.mat-footer-cell{padding: 0px 10px 0px 0px;border-bottom-width: 1px;border-bottom-style: solid;border-bottom-color: lightgrey;}'
                    +'th.mat-header-cell{ font-size: 12px; }';
        if(typeof options !== "undefined"){
            if(typeof options.header !== "undefined"){
                header = '<h3>'+options.header+'</h3>'
            }
            if(typeof options.title !== "undefined"){
                title = options.title
            }
            if(typeof options.style !== "undefined"){
                style = options.style
            }
            if(typeof options.url !== "undefined"){
                url  += "/"+options.url
            }
        }
        if(!portrait){
            withInch = 10.5;
        }

        // var a = window.open('', 'PrintableData', 'height=1000, width=1000');
        let footerVersion:HTMLElement | null = document.getElementById("footerVersion");
        let footerVerstionHtml = footerVersion === null ? "" : footerVersion.innerHTML
        let foorterCopyRight:HTMLElement | null = document.getElementById("footerCopyRight");
        let footerCopyRightHtml = foorterCopyRight === null ? "" : foorterCopyRight.innerHTML
        var a = window.open();
        pageContent = '<html><head><title>'+title+'</title></head>'
                    +'<body> <style>'
                    +'img {max-width: '+withInch.toString()+'in;border: 1px solid lightgray;border-radius: 10px;}  '
                    +'table {width:'+withInch.toString()+'in;font-size: 12px; text-align:left;}'
                    +'tbody > tr {height:20px;} h3{text-align: center;}'
                    +'@media print{.printButton{display: none;}}'
                    +'.no-print{display:none;}'
                    +style+'</style>'
                    +'<button class="printButton" onclick="window.print()" >Print Page</button>'
                    +'<div  style="width:'+withInch.toString()+'in;padding-top:12px; ">'
                    +header
                    +htmlData
                    +'<br><div style="width:100%; font-size:12px;display: inline-flex;"> <div style="width:50%;">'+footerVerstionHtml+'</div> <div style="width:50%; text-align:right;">'+footerCopyRightHtml+'</div></div>'
                    +'</div><br>'
                    // +'<div style="display:flex; width:'+withInch.toString()+'in; font-size:12px;"><div style="width:50%;">'+document.getElementById("footerVersion").innerHTML+'</div>   <div style="width:50%; text-align: right;">'+document.getElementById("footerCopyRight").innerHTML+'</div></div>'
                    +'<script>setTimeout(()=>{document.title = "'+title+'";window.history.pushState("_empty_", "Title", "/'+url+'");window.print();},250);</script>'
                    //+"<script>alert('Helo');</script>"
                    +'</body></html>'
        if(a !== null){
            a.document.write(pageContent);
            a.document.close();
        }else{
            success = false;
        }
        
        return success
    }

    public loadScript(name: string):Promise<void>{
        return new Promise((resolve, reject) => {
            let script = document.createElement('script');
            script.type = 'text/javascript';
            script.src = name;
            document.getElementsByTagName('body')[0].appendChild(script);
            setTimeout(()=>{
                resolve()
            },0)
            
        });
    }
}